import React from 'react';
import ButtonTwo from '../Button/ButtonTwo';


import shapeImg1 from '../../assets/img/slider/shape-1-1.png';
import shapeImg2 from '../../assets/img/slider/shape-1-2.png';
import shapeImg3 from '../../assets/img/slider/shape-1-3.png';
import Image from '../../assets/img/slider/slide-1-1.jpg';


const SingleSlider = (props) => {
  const { itemClass, sliderImage, title, description, btnTextOne, btnTextTwo } =
    props;
  return (



    
    <div
      className={
        itemClass ? itemClass : 'it-slider-height fix p-relative z-index'
      }
    >


<style>
        {`
          @keyframes flashZoom {
            0% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(255, 0, 0, 0.7);
            }
            50% {
              transform: scale(1.15);
              box-shadow: 0 0 20px rgba(255, 0, 0, 0.9);
            }
            100% {
              transform: scale(1);
              box-shadow: 0 0 0 rgba(255, 0, 0, 0.7);
            }
          }

          .flash-zoom {
            animation: flashZoom 1.5s ease-in-out infinite;
            position: relative;
            z-index: 2;
          }
        `}
      </style>

      <div className="it-slider-shape-1">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="it-slider-shape-2">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-slider-shape-3">
        <img src={shapeImg3} alt="" />
      </div>
      <div
        className="it-slider-bg"
        style={{ backgroundImage: `url(${sliderImage ? sliderImage : Image})` }}
      ></div>
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-xl-8 col-lg-10">
            <div className="it-slider-content">
              <h1 className="it-hero-title text-white pb-10">
                {title
                  ? title
                  : 'Caring Hearts, Healing Hands Our Cardiology Practice'}
              </h1>
              <div className="it-hero-text">
                <p className="text-white">
                  {description
                    ? description
                    : `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation .`}
                </p>
                <div className="it-slider-button mt-35">
                 <ButtonTwo
                    btnURL="https://appointments.ricgop.online/#appointment"
                    btnClass="it-btn-theme red-bg mr-35 flash-zoom"
                    btnText={btnTextOne ? btnTextOne: 'Book Appointment'}
                  />
                  <ButtonTwo
                    btnURL="/about-us"
                    btnClass="it-btn-theme red-bg border-btn mr-35"
                    btnText={btnTextTwo ? btnTextTwo : 'Read More'}
                  />
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleSlider;
